module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-page', [_c('c-content', [(_vm.banners.length > 0) ? _c('c-swipe', {
    attrs: {
      "images": _vm.banners,
      "auto": 0
    },
    on: {
      "click": _vm.bannerClick
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.panelItems), function(item) {
    return [(item.title) ? _c('c-panel-container', [_c('c-panel-title', [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('c-panel-container', _vm._l((item.items), function(panelItem) {
      return _c('c-panel', {
        key: panelItem.title,
        attrs: {
          "img": panelItem.img,
          "title": panelItem.title,
          "desc": panelItem.desc
        },
        nativeOn: {
          "click": function($event) {
            _vm.showDetail(panelItem)
          }
        }
      }, [_c('div', {
        staticClass: "price",
        staticStyle: {
          "overflow": "hidden"
        },
        domProps: {
          "innerHTML": _vm._s(panelItem.price)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "right-point"
      })])
    }))]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7233a2a4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tabs/value-added-service/index.vue
// module id = 1061
// module chunks = 2